import React from 'react';
import { Plus, Eye, Edit, Trash2, Search } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Select } from '../components/ui/Select';
import { Link } from 'react-router-dom';
export function SectionQuestions() {
  const questions = [{
    id: 101,
    question: 'What is the primary water source for desert flora?',
    answer: 'yes',
    section: 'Section 1',
    course: 'Desert Ecology Basics',
    created: '2023-01-15',
    modified: '2023-06-20'
  }, {
    id: 102,
    question: 'Does the Saguaro cactus grow in the Mojave desert?',
    answer: 'no',
    section: 'Section 2',
    course: 'Desert Ecology Basics',
    created: '2023-01-16',
    modified: '2023-01-16'
  }, {
    id: 103,
    question: 'Is drip irrigation more efficient than sprinklers?',
    answer: 'yes',
    section: 'Section 1',
    course: 'Sustainable Landscaping',
    created: '2023-02-10',
    modified: '2023-08-05'
  }];
  return <div className="space-y-6" data-id="element-748">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-749">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-750">Section Questions</h1>
        <Link to="/questions/add" data-id="element-751">
          <Button className="gap-2 w-full sm:w-auto" data-id="element-752">
            <Plus className="h-4 w-4" data-id="element-753" />
            Add
          </Button>
        </Link>
      </div>

      <Card className="p-4" data-id="element-754">
        <div className="flex flex-col md:flex-row gap-4 items-end" data-id="element-755">
          <div className="w-full md:w-1/3" data-id="element-756">
            <Select label="Course" options={[{
            value: '',
            label: 'All Courses'
          }, {
            value: '1',
            label: 'Desert Ecology Basics'
          }, {
            value: '2',
            label: 'Advanced Water Conservation'
          }]} data-id="element-757" />
          </div>
          <div className="w-full md:w-1/3" data-id="element-758">
            <Select label="Section" options={[{
            value: '',
            label: 'All Sections'
          }, {
            value: '1',
            label: 'Section 1'
          }, {
            value: '2',
            label: 'Section 2'
          }]} data-id="element-759" />
          </div>
          <Button variant="secondary" className="gap-2 w-full md:w-auto" data-id="element-760">
            <Search className="h-4 w-4" data-id="element-761" />
            Search
          </Button>
        </div>
      </Card>

      <Card className="overflow-hidden" data-id="element-762">
        <div className="overflow-x-auto" data-id="element-763">
          <table className="w-full text-sm text-left" data-id="element-764">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-765">
              <tr data-id="element-766">
                <th className="px-4 py-3" data-id="element-767">Id</th>
                <th className="px-4 py-3 w-1/3" data-id="element-768">Question</th>
                <th className="px-4 py-3" data-id="element-769">Answer</th>
                <th className="px-4 py-3" data-id="element-770">Section</th>
                <th className="px-4 py-3" data-id="element-771">Course</th>
                <th className="px-4 py-3" data-id="element-772">Created</th>
                <th className="px-4 py-3" data-id="element-773">Modified</th>
                <th className="px-4 py-3" data-id="element-774">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-775">
              {questions.map(q => <tr key={q.id} className="hover:bg-slate-50" data-id="element-776">
                  <td className="px-4 py-3 text-slate-500" data-id="element-777">{q.id}</td>
                  <td className="px-4 py-3 line-clamp-2" data-id="element-778">{q.question}</td>
                  <td className="px-4 py-3 capitalize" data-id="element-779">{q.answer}</td>
                  <td className="px-4 py-3" data-id="element-780">
                    <Link to="#" className="text-blue-600 hover:underline" data-id="element-781">
                      {q.section}
                    </Link>
                  </td>
                  <td className="px-4 py-3" data-id="element-782">
                    <Link to="#" className="text-blue-600 hover:underline" data-id="element-783">
                      {q.course}
                    </Link>
                  </td>
                  <td className="px-4 py-3 text-slate-500" data-id="element-784">{q.created}</td>
                  <td className="px-4 py-3 text-slate-500" data-id="element-785">{q.modified}</td>
                  <td className="px-4 py-3" data-id="element-786">
                    <div className="flex items-center gap-2" data-id="element-787">
                      <Button variant="ghost" size="icon" title="View" data-id="element-788">
                        <Eye className="h-4 w-4 text-slate-500" data-id="element-789" />
                      </Button>
                      <Link to={`/questions/edit/${q.id}`} data-id="element-790">
                        <Button variant="ghost" size="icon" title="Edit" data-id="element-791">
                          <Edit className="h-4 w-4 text-blue-600" data-id="element-792" />
                        </Button>
                      </Link>
                      <Button variant="ghost" size="icon" title="Delete" data-id="element-793">
                        <Trash2 className="h-4 w-4 text-red-600" data-id="element-794" />
                      </Button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}